import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ListModel, MusicLoadedModel, SongModel } from '@models/music.model';
import { MusicService } from '@services/music.service';
import { forkJoin, map, tap } from 'rxjs';
import { DataStore } from '../dataset/dataset.store';


export const datalistResolver: ResolveFn<ListModel> = (route, state) => {
	const musicSvc = inject(MusicService);
	const dataStore = inject(DataStore);
	return musicSvc.getLists().pipe(
        tap((lists: ListModel) => dataStore.setListsFromResolver(lists))
    )
};